import ERROR_MESSAGES from './constants';

const validations = {
  domain: {
    required: {
      value: true,
      message: ERROR_MESSAGES.DOMAIN_REQUIRED,
    },
    domain: {
      value: true,
      message: ERROR_MESSAGES.DOMAIN_INVALID,
    },
  },
  email: {
    required: {
      value: true,
      message: ERROR_MESSAGES.EMAIL_REQUIRED,
    },
    email: {
      value: true,
      message: ERROR_MESSAGES.WRONG_EMAIL_FORMAT,
    },
  },
  password: {
    required: {
      value: true,
      message: ERROR_MESSAGES.PASSWORD_REQUIRED,
    },
  },
};
export default validations;
